import { BaseResponseFormatter } from "../../../base";
export class MultiEventResponseFormatter extends BaseResponseFormatter {
}
//# sourceMappingURL=MultiEventResponseFormatter.js.map